import React, { Component } from "react";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import DataStore from "./../../stores/DataStore";
import { red, yellow, blue } from "@mui/material/colors";
import { observer } from "mobx-react";
/**
 * @component
 * Modul, welches Nachrichten für ein Attribut anzeigt.
 *
 */
class AttributMessage extends Component {
  constructor(params) {
    super(params);
    this.state = {
      isVisible: false,
    };
    const { ruleHandler } = params;
    ruleHandler.attributeMessageModul = this;
  }

  componentDidMount() {
    const { ruleHandler } = this.props;
    ruleHandler.attributeMessageModul = this;
  }

  /**
   * @return {object} Icon je nach type
   */
  getIcon() {
    const { ifViolatedType = "error" } = this.props;
    switch (ifViolatedType) {
      case "error": {
        return <ErrorIcon style={{ color: red[500] }} />;
      }
      case "warning": {
        return <WarningIcon style={{ color: yellow[500] }} />;
      }
      case "message": {
        return <InfoIcon style={{ color: blue[500] }} />;
      }
      case "loading": {
        return <CircularProgress />;
      }
      default: {
        return <ErrorIcon style={{ color: red[500] }} />;
      }
    }
  }

  hide() {
    this.setState({ isVisible: false });
  }

  show() {
    this.setState({ isVisible: true });
  }

  /**
   * Modul, welches Nachrichten für ein Attribut anzeigt.
   * @render
   * @param {object} this.state
   * @param {object} this.props
   * @param {string} this.props.message - ID des Attributes
   * @param {string} this.props.type - Typ der Nachricht (error, warning, information, ...)
   * @param {boolean} this.state.isVisible - Gibt an, ob die Nachricht grade angezeigt werden soll oder nicht.
   */
  render() {
    const {
      ifViolatedText = "Fehlerhafter Wert",
      ifViolatedTextKey,
      ifViolatedTextStore,
    } = this.props;
    const { isVisible } = this.state;
    this.ifViolatedText = ifViolatedText;
    if (ifViolatedTextKey && ifViolatedTextStore) {
      this.ifViolatedText = ifViolatedTextStore[ifViolatedTextKey];
    }
    if (isVisible) {
      return (
        <span style={{ display: "block" }}>
          <Tooltip title={this.ifViolatedText}>{this.getIcon()}</Tooltip>
        </span>
      );
    }
    return <div />;
  }
}

export default observer(AttributMessage);
